<template>
  <div class="myInfoWrapper">
    <withdraw/>
    <div class="myInfoContentWrapper">
      <div class="myInfoHeader" v-bind:style="style.myInfoHeaderResize">
        <div class="myInfoHeadLine">
          <span>내정보</span>
          <div class="configDiv" v-on:mouseover="isConfigMenuShow = true" v-on:mouseleave="isConfigMenuShow = false" v-bind:style="style.displayOnNotEditable">
            <img class="configIcon" v-bind:src="configIcon">
            <transition name="fade">
              <div class="configMenu" v-show="isConfigMenuShow">
                <div class="withdrawMenu" v-on:click="onClickWithdrawMenu">회원탈퇴</div>
              </div>
            </transition>
          </div>
        </div>
        <span class="itemName" v-bind:style="style.displayOnEditable">닉네임</span>
        <div class="myInfoDiv">
          <div class="myInfoNameTextInputDiv">
            <input type="text" v-model="myInfo.name" v-bind:maxlength="12" v-bind:style="style.inputTextEditable" v-on:keyup="returnNameLength">
            <span v-bind:style="style.displayOnEditable">{{lengthInfo.nameLength + '/12'}}</span>
          </div>
          <input type="button" class="modifyButton" value="수정하기" v-bind:style="style.displayOnNotEditable" v-on:click="onclickModifyButton">
        </div>
        <div class="myInfoValidTextWrapper">
          <span v-if="isEditable && validText.noName">* 이름을 입력해 주세요.</span>
          <span v-if="isEditable && validText.duplicateName">* 중복된 이름입니다.</span>
        </div>
        <span class="itemName" v-bind:style="style.displayOnEditable">대표이미지</span>
        <div class="myInfoImgDiv">
          <input-img v-for="index in [0, 1, 2, 3, 4]" v-bind:key="index" v-bind:img-index="index" v-bind:init-img-url="myInfo.images[index]"></input-img>
        </div>
        <div class="myInfoValidTextWrapper" v-bind:style="'margin-top:20px;'">
          <span v-if="isEditable && validText.noImage">* 최소 1장의 이미지를 설정해주세요.</span>
        </div>
      </div>
      <div class="myInfoContent">
        <div class="sectionLine" v-bind:style="style.displayOnEditable"></div>
        <div class="myInfoAddressDiv">
          <span class="itemName">주소</span>
          <div class="myInfoAddressTextInputDiv">
            <input type="text" v-bind:maxlength="40" v-model="myInfo.address" v-bind:style="style.inputTextEditable" v-on:keyup="returnAddressLength">
            <span v-bind:style="style.displayOnEditable">{{lengthInfo.addressLength + '/40'}}</span>
          </div>
          <div class="myInfoValidTextWrapper">
            <span v-if="isEditable && validText.noAddress">* 주소를 입력해 주세요.</span>
          </div>
        </div>
        <div class="myInfoDetailAndModifyDiv">
          <span class="itemName">설명글</span>
          <div class="myInfoDetailTextDiv">
            <div class="myInfoDetailTextInputDiv">
              <textarea rows="5" v-bind:maxlength="200" v-model="myInfo.detailText" v-bind:style="style.inputTextAreaEditable" v-bind:disabled="!isEditable" v-on:keyup="returnDetailLength"></textarea>
              <span v-bind:style="style.displayOnEditable">{{lengthInfo.detailTextLength + '/200'}}</span>
              <div class="myInfoValidTextWrapper">
                <span v-if="isEditable && validText.noDescription">* 설명글을 입력해 주세요.</span>
              </div>
            </div>
            <div class="myInfoModifyConfirmDiv">
              <input type="button" class="cancelButton" value="취소" v-bind:style="style.displayOnEditableInline" v-on:click="onclickCancelButton">
              <input type="button" class="confirmButton" value="확인" v-bind:style="style.displayOnEditableInline" v-on:click="onclickConfirmButton">
            </div>
          </div>
        </div>
        <div class="sectionLineNotEditable" v-bind:style="style.displayOnNotEditable"></div>
        <div class="myInfoCertificateDiv" v-bind:style="style.displayOnNotEditable">
          <span class="certificateTitle">나의 사업자등록증</span>
          <div class="certificateTextDiv">
            <span v-if="$store.getters.getAdUserStateValue('certificate') == null || $store.getters.getAdUserStateValue('certificate') === ''"
                  v-on:click="openCertificateRegistrationModal('register')">등록증등록</span>
            <span v-if="$store.getters.getAdUserStateValue('certificate') != null && $store.getters.getAdUserStateValue('certificate') !== ''"
                  v-on:click="openCertificateNewWindow">등록증보기</span>
            <span v-if="$store.getters.getAdUserStateValue('certificate') != null && $store.getters.getAdUserStateValue('certificate') !== ''"
                  v-on:click="openCertificateRegistrationModal('modify')">등록증편집</span>
            <cert-reg />
          </div>
          <div class="taxBillTextDiv" v-if="$store.getters.getAdUserStateValue('certificate') != null && $store.getters.getAdUserStateValue('certificate') !== ''">
            <img class="checkButton" v-bind:src="taxBillCheckImg" v-on:click="onTaxBillCheck">
            <span>매달 세금계산서 발행하기</span>
          </div>
        </div>
      </div>
    </div>
    <board-footer></board-footer>
  </div>
</template>

<script>
import inputImg from '../../board/elements/myInfoInputImg.vue'
import certificateRegistration from '../../board/elements/certificateRegistrationModal.vue'
import withdrawModal from '../elements/withdrawModal'
import boardFooter from '../elements/boardFooter'
import store from '../../../store'

export default {
  components: {
    'input-img': inputImg,
    'cert-reg': certificateRegistration,
    'board-footer': boardFooter,
    'withdraw': withdrawModal
  },
  data () {
    return {
      myInfo: {
        name: '',
        address: '',
        detailText: '',
        images: [],
        invoice: false,
        certificate: ''
      },
      lengthInfo: {
        nameLength: 0,
        addressLength: 0,
        detailTextLength: 0
      },
      isEditable: false,
      isModalShown: false,
      validText: {
        noName: false,
        duplicateName: false,
        noImage: false,
        noAddress: false,
        noDescription: false
      },
      myInfosBeforeEdit: null,
      lengthInfoBeforeEdit: null,
      configIcon: require('@/assets/img/my_info_config_icon.png'),
      isConfigMenuShow: false,
      style: {
        myInfoHeaderResize: '',
        displayOnEditable: '',
        displayOnEditableInline: '',
        displayOnNotEditable: '',
        inputTextEditable: '',
        inputTextAreaEditable: ''
      }
    }
  },
  methods: {
    onClickWithdrawMenu: function () {
      this.$modal.show('withdraw')
    },
    onclickModifyButton: function () {
      if(!this.isEditable) {
        this.$store.commit('setMyInfoStateValue', {type: 'isEditable', value: true})
      }
    },
    returnNameLength: function (e) {
      this.lengthInfo.nameLength = e.target.value.length > 12 ? 12 : e.target.value.length
    },
    returnAddressLength: function (e) {
      this.lengthInfo.addressLength = e.target.value.length > 40 ? 40 : e.target.value.length
    },
    returnDetailLength: function (e) {
      this.lengthInfo.detailTextLength = e.target.value.length > 200 ? 200 : e.target.value.length
    },
    onclickCancelButton: function () {
      Object.assign(this.lengthInfo, this.lengthInfoBeforeEdit)
      Object.assign(this.myInfo, this.myInfosBeforeEdit)
      this.$store.commit('setMyInfoStateValue', {type: 'imgReloadTrigger', value: !this.$store.getters.getMyInfoStateValue('imgReloadTrigger')})
      this.$store.commit('setMyInfoStateValue', {type: 'isEditable', value: false})
      this.validText.noName = false
      this.validText.noImage = false
      this.validText.noAddress = false
      this.validText.noDescription = false
    },
    onclickConfirmButton: async function () {
      this.validText.noName = false
      this.validText.noImage = false
      this.validText.noAddress = false
      this.validText.noDescription = false

      let name = this.myInfo.name
      let address = this.myInfo.address
      let description = this.myInfo.detailText
      let images = this.$store.getters.getTempImgStore

      if(this.modifyValidCheck(name, address, description, images)) {
        try {
          let modifyInfo = {
            name: name,
            address: address,
            description: description,
            images: await this.replaceImageInfo(this.$store.getters.getAdUserStateValue('images'), this.$store.getters.getTempImgStore)
          }
          // axios.post 처리
          let response = await this.adUserInfoModify(modifyInfo)
          if(response.data.result.code === 1001 && response.data.result.message === 'DUPLICATED_NICKNAME') {
            // 중복닉네임
            this.validText.duplicateName = true
          }else {
            // 에러없음
            // 수정상태 false로 변경
            this.$store.commit('setMyInfoStateValue', {type: 'isEditable', value: false})
            // 저장한 정보들 store에 저장 처리
            await this.$store.dispatch('adUserInfoApi')
          }
        }catch (error) {
          console.log(error.response)
          alert('회원정보 갱신에 실패했습니다.')
        }
      }
    },
    replaceImageInfo: async function (beforeImage, afterImages) {
      // tempImgStore -> aduser.image 셋팅처리

      // null요소 전부 제거
      let deleteImgIndex = []
      for (var i = 0; i < 5; i++) {
        // 기존 이미지와 앞으로 바뀔 이미지의 index가 겹치는지 확인
        if (afterImages[i] != null && beforeImage[i] != null) {
          deleteImgIndex.push(i)
        }
      }
      // 겹치는 기존 이미지가 있을 시 기존이미지 삭제 처리
      if(deleteImgIndex.length !== 0) {
        await this.$store.dispatch('deleteAdUserImagesApi', {values: deleteImgIndex})
      }
      return afterImages.filter(arr => arr != null && arr !== false)
    },
    setStyleChangeByIsEditable: function (isEditable) {
      this.isEditable = isEditable
      this.style.myInfoHeaderResize = isEditable ? 'height: 480px;' : ''
      this.style.displayOnEditable = isEditable ? 'display: block;' : ''
      this.style.displayOnEditableInline = isEditable ? 'display: inline-block;' : ''
      this.style.displayOnNotEditable = isEditable ? 'display: none;' : ''
      this.style.inputTextEditable = isEditable ? 'pointer-events: auto; border-bottom: 2px rgb(112,112,112) solid;' : ''
      this.style.inputTextAreaEditable = isEditable ? 'border-bottom: 2px rgb(112,112,112) solid;' : ''
    },
    adUserInfoModify: async function (modifyInfo) {
      try {
        return await this.$store.dispatch('modifyAdUserInfoApi', modifyInfo)
      }catch (error) {
        console.log(error.response)
      }
    },
    openCertificateRegistrationModal: function (type) {
      this.$modal.show('certReg', {type: type, certificate: this.myInfo.certificate})
    },
    openCertificateNewWindow: function () {
      window.open(this.$store.getters.getAdUserStateValue('certificate'), '_blank')
    },
    onTaxBillCheck: async function () {
      let flg = this.myInfo.invoice === false || this.myInfo.invoice == null
        ? confirm('매달 세금계산서를 발행하시겠습니까?') : confirm('매달 세금계산서 발행을 취소하시겠습니까?')
      if (flg) {
        let invoice = this.myInfo.invoice !== false && this.myInfo.invoice != null
        await this.$store.dispatch('modifyAdUserInvoiceApi', {invoice: !invoice})
        // 세금계산서 발행 정보 store에 저장 처리
        await this.$store.dispatch('adUserInfoApi')
      }
    },
    modifyValidCheck: function (name, address, description, images) {
      if(name === '' || name == null || name.trim() === '') {
        this.validText.noName = true
        return false
      }
      if(address === '' || address == null || address.trim() === '') {
        this.validText.noAddress = true
        return false
      }
      if(description === '' || description == null || description.trim() === '') {
        this.validText.noDescription = true
        return false
      }

      let noChangedImgCnt = images.filter(arr => arr == null).length
      let deletedImgCnt = images.filter(arr => arr === false).length
      let nowImg = this.$store.getters.getAdUserStateValue('images')
      if(nowImg[0] == null && noChangedImgCnt + deletedImgCnt === 5) {
        // 기존이미지 없음, no수정
        this.validText.noImage = true
        return false
      } else if(nowImg[0] != null && images[0] === false && nowImg.length === deletedImgCnt && noChangedImgCnt + deletedImgCnt === 5) {
        // 기존이미지 있음, 이미지 전부 삭제
        this.validText.noImage = true
        return false
      }
      return true
    }
  },
  beforeRouteEnter (to, from, next) {
    // accessToken 유효한지 체크
    if (store.getters.getAccessToken == null || store.getters.getAccessToken === '' ||
      store.getters.getRefreshToken == null || store.getters.getRefreshToken === '') {
      // 비정상적인 접근
      alert('비 정상적인 경로로 진입하여 로그인 페이지로 이동합니다.')
      localStorage.removeItem('vuex')
      next('/')
    }else{
      next()
    }
  },
  created: async function () {
    this.myInfo.name = this.$store.getters.getAdUserStateValue('name')
    this.myInfo.address = this.$store.getters.getAdUserStateValue('address')
    this.myInfo.detailText = this.$store.getters.getAdUserStateValue('description')
    this.myInfo.images = this.$store.getters.getAdUserStateValue('images')
    this.myInfo.invoice = this.$store.getters.getAdUserStateValue('invoice')
    this.myInfo.certificate = this.$store.getters.getAdUserStateValue('certificate')
    this.lengthInfo.detailTextLength = this.myInfo.detailText != null ? this.myInfo.detailText.length : 0
    this.lengthInfo.addressLength = this.myInfo.address != null ? this.myInfo.address.length : 0
    this.lengthInfo.nameLength = this.myInfo.name != null ? this.myInfo.name.length : 0
    this.myInfosBeforeEdit = Object.assign({}, this.myInfo)
    this.lengthInfoBeforeEdit = Object.assign({}, this.lengthInfo)
    this.setStyleChangeByIsEditable(this.$store.getters.getMyInfoStateValue('isEditable'))
  },
  mounted: function () {
    this.$store.watch(() => this.$store.getters.getMyInfoStateValue('isEditable'), value => {
      this.setStyleChangeByIsEditable(value)
    })
    this.$store.watch(() => this.$store.getters.getAdUserState, value => {
      this.myInfo.name = value.name
      this.myInfo.address = value.address
      this.myInfo.detailText = value.description
      this.myInfo.images = value.images
      this.myInfo.invoice = value.invoice
      this.myInfo.certificate = value.certificate
      // 회원정보 변경시 이미지 리로드
      this.$store.commit('setMyInfoStateValue', {type: 'imgReloadTrigger', value: !this.$store.getters.getMyInfoStateValue('imgReloadTrigger')})
      // 백업용 오브젝트 변경
      Object.assign(this.myInfosBeforeEdit, this.myInfo)
      Object.assign(this.lengthInfoBeforeEdit, this.lengthInfo)
    })
  },
  computed: {
    taxBillCheckImg: function () {
      return this.myInfo.invoice ? require('@/assets/img/checkbox_selected_img.png') : require('@/assets/img/checkbox_not_selected_img.png')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../../assets/css/board.css';
.myInfoWrapper{
  display : -webkit-flex;
  display : flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: white;
  margin: 0;
  padding: 0;
  flex: 0.97;
}

.myInfoContentWrapper{
  display : -webkit-flex;
  display : flex;
  flex-direction: column;
  height: calc(100% - 82px);
}

.myInfoHeader{
  display : -webkit-flex;
  display : flex;
  flex-direction: column;
  padding: 0 32px;
}

.myInfoHeader > .itemName{
  display: none;
  margin-top: 20px;
  padding: 0;
  font-size: 11px;
  color: rgb(0,153,255);
}

.myInfoHeadLine {
  display : -webkit-flex;
  display : flex;
  justify-content: space-between;
  font-size: 24px;
  padding-top: 70px;
  padding-bottom: 15px;
}

.configIcon {
  cursor: pointer;
  width: 40px;
  height: 40px;
}

.myInfoDiv{
  display : -webkit-flex;
  display : flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  height: 48px;
}

.myInfoNameTextInputDiv{
  width: 320px;
}

.myInfoNameTextInputDiv > input[type="text"]{
  pointer-events: none;
  padding: 0 0 5px;
  font-weight: bold;
  font-size: 20px;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: none;
  width: 100%;
  outline: none;
}

.myInfoNameTextInputDiv > span{
  text-align: right;
  display: none;
  font-size: 8px;
}

.myInfoDiv .modifyButton{
  cursor: pointer;
  border-radius: 8px;
  border: none;
  outline: none;
  font-size: 15px;
  font-weight: bold;
  color: white;
  width: 196px;
  height: 100%;
  background-color: rgb(0,153,255);
}

.myInfoImgDiv{
  display : -webkit-flex;
  display : flex;
  height: 156px;
}

.myInfoContent{
  padding: 20px 32px 0 32px;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.myInfoContent::-webkit-scrollbar{
  display: none;
}

.myInfoContent > .sectionLine{
  display: none;
  border-bottom: rgb(172,172,172) solid 1px;
  width: 100%;
  margin-bottom: 40px;
}

.myInfoContent .itemName{
  display: block;
  margin-bottom: 20px;
  padding: 0;
  font-size: 11px;
  color: rgb(0,153,255);
}

.myInfoAddressDiv{
  margin-bottom: 30px;
}

.myInfoCertificateDiv {
  margin-top: 30px;
}

.myInfoAddressTextInputDiv > span{
  text-align: right;
  display: none;
  font-size: 8px;
  width: 540px;
}

.myInfoAddressTextInputDiv > input[type="text"]{
  display: block;
  pointer-events: none;
  padding: 0 0 5px;
  font-size: 13px;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: none;
  outline: none;
  width: 540px;
}

.myInfoDetailTextDiv{
  display: flex;
  display: -ms-flexbox;
  justify-content: space-between;
  align-items: flex-end;
}

.myInfoDetailTextInputDiv{
  text-align: right;
}

.myInfoDetailTextInputDiv textarea{
  padding: 0 0 5px;
  font-size: 13px;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: none;
  outline: none;
  width: 624px;
  resize: none;
}

.myInfoDetailTextInputDiv textarea:disabled{
  background: white;
}

.myInfoDetailTextInputDiv > span{
  display: none;
  font-size: 8px;
}

.myInfoModifyConfirmDiv{
  text-align: right;
}

.myInfoModifyConfirmDiv .cancelButton{
  cursor: pointer;
  display: none;
  width: 100px;
  height: 48px;
  border-radius: 8px;
  border: rgb(0,153,255) 2px solid;
  outline: none;
  text-align: center;
  font-size: 15px;
  font-weight: bold;
  color: rgb(0,153,255);
  background-color: white;
  margin-right: 10px;
}

.myInfoModifyConfirmDiv .confirmButton{
  cursor: pointer;
  display: none;
  width: 100px;
  height: 48px;
  border-radius: 8px;
  border: none;
  outline: none;
  text-align: center;
  font-size: 15px;
  font-weight: bold;
  color: white;
  background-color: rgb(0,153,255);
}

.certificateTitle{
  font-size: 14px;
}

.certificateTextDiv{
  padding: 20px 0;
}

.certificateTextDiv > span{
  cursor: pointer;
  margin-right: 20px;
  font-size: 12px;
  text-decoration: underline;
}

.taxBillTextDiv{
  display: flex;
  display: -ms-flexbox;
  align-items: center;
  padding-right: 20px;
  font-size: 12px;
}

.taxBillTextDiv > .checkButton{
  width: 32px;
  height: 32px;
  cursor: pointer;
}

.myInfoValidTextWrapper{
  text-align: left;
  padding-top: 5px;
}

.myInfoValidTextWrapper > span{
  color: red;
  font-size: 10px;
}

.sectionLineNotEditable {
  border-bottom: rgb(172,172,172) solid 1px;
  width: 100%;
}

.configDiv{
  position: relative;
  height: 40px;
}

.configMenu{
  position: absolute;
  font-size: 13px;
  top: 40px;
  left: calc(100% - 120px);
  border: 1px solid #707070;
  z-index: 1;
  width: 120px;
}

.configMenu > div {
  cursor: pointer;
  display: flex;
  display: -ms-flexbox;
  justify-content: center;
  align-items: center;
  height: 38px;
  background-color: white;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/board/views/myInfo.vue